import { createReducer, on } from '@ngrx/store';
import {
  getExtraCostConfigFileFailure,
  getExtraCostConfigFileRequest,
  getExtraCostConfigFileSuccess,
} from '../actions';

import { parse } from 'src/app/my-bill/services/extra-cost-csv-parser.service';
import { ExtraCostCsvParseResult } from 'src/app/my-bill/models/extra-cost.model';

export interface ExtraCostConfigFileState {
  extraCostConfig: ExtraCostCsvParseResult | null;
  hasError: boolean;
  isFetching: boolean;
}

export const initialState: ExtraCostConfigFileState = {
  extraCostConfig: null,
  hasError: false,
  isFetching: false,
};

export const extraCostConfigFileReducer = createReducer(
  initialState,
  on(getExtraCostConfigFileRequest, (state) => ({
    ...state,
    hasError: false,
    isFetching: true,
  })),
  on(getExtraCostConfigFileSuccess, (state, { csvResponse }) => ({
    ...state,
    extraCostConfig: parse(csvResponse),
    hasError: false,
    isFetching: false,
  })),
  on(getExtraCostConfigFileFailure, (state) => ({
    ...state,
    hasError: true,
    isFetching: false,
  }))
);
